import React, { FC } from 'react';
import { Slider, Typography } from '@mui/material';

import './NumberSlider.scss';

type NumberSliderProps = {
  value: number;
  setValue: (value: number) => void;
  step?: number;
  min?: number;
  max?: number;
  title?: string;
};

const NumberSlider: FC<NumberSliderProps> = ({
  value,
  setValue,
  title = '',
  step = 1,
  min = 1,
  max = 10,
}) => {
  const handleChange = (event: Event, newValue: number | number[]) => {
    if (typeof newValue === 'number') {
      setValue(newValue);
    }
  };

  return (
    <div className={'number-slider'}>
      <Typography className={'number-slider__title'} gutterBottom>
        {title}
      </Typography>

      <Slider
        value={value}
        onChange={handleChange}
        step={step}
        min={min}
        max={max}
        valueLabelDisplay="on"
      />
    </div>
  );
};

export default NumberSlider;
